export const DEFAULT_PROFILE_IMAGE = "/img/icons/UserFalse.svg";

export const normalizeImageSrc = (val) => {
  if (!val) return null;

  if (typeof val === "object") {
    return normalizeImageSrc(val.content ?? val.src ?? val.url);
  }

  const src = String(val).trim();
  if (!src) return null;

  if (src.startsWith("data:image")) return src;

  const looksBase64 = /^[A-Za-z0-9+/=\s]+$/.test(src) && src.length > 100;
  return looksBase64 ? `data:image/png;base64,${src}` : src;
};

export const getUserId = (user = {}) =>
  user?.idUsuario ??
  user?.IdUsuario ??
  user?.idAmigo ??
  user?.IdAmigo ??
  user?.id ??
  user?.userId ??
  user?.idUsuarioOrigen ??
  null;

export const getProfileImageFromUser = (user = {}) =>
  normalizeImageSrc(
    user?.fotoPerfilUrl ??
      user?.profilePic ??
      user?.imagenBase64 ??
      user?.fotoPerfilBase64 ??
      user?.imagenPerfil ??
      user?.imageUrl ??
      null,
  );

export const sameUser = (left = {}, right = {}) => {
  const leftId = getUserId(left);
  const rightId = getUserId(right);
  return Boolean(leftId && rightId && String(leftId) === String(rightId));
};
